$(window).load(function () {
  var $svg = $('.animated_lines .svg_block svg')
  var $svg_time = 0
  $svg.each(function () {
    var $this = $(this)
    setTimeout(function () {
      $this.show().addClass('path')
      // .find('.top, .top2, .middle, .middle2, .bottom, .bottom2')
    }, $svg_time)
    $svg_time = $svg_time + 1000
  })

  var $time = 0
  var $text = $('.animated_lines__text h3')

  $text.each(function () {
    var $el = $(this)
    $time = $time + 800
    setTimeout(function () {
      $el.fadeIn()
    }, $time)
  })
})
